"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_toastify_1 = require("react-toastify");
var react_toastify_2 = require("react-toastify");
require("!style-loader!css-loader!react-toastify/dist/ReactToastify.css");
var AcToast = function (props) {
    var notify = function () { return react_toastify_1.toast(props.message); };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("button", { onClick: notify }, "Notify !")));
};
exports.AcToast = AcToast;
var dismissMessage = function (toastId) {
    return toastId ? react_toastify_1.toast.dismiss(toastId) : react_toastify_1.toast.dismiss();
};
exports.dismissMessage = dismissMessage;
var notifyMessage = function (message, role, millisToDisplay) {
    switch (role) {
        case 'INFO':
            return react_toastify_1.toast.info(message, millisToDisplay ? { autoClose: millisToDisplay } : {});
            break;
        case 'SUCCESS':
            return react_toastify_1.toast.success(message, millisToDisplay ? { autoClose: millisToDisplay, transition: react_toastify_2.Flip } : {});
            break;
        case 'WARNING':
            return react_toastify_1.toast.warn(message, millisToDisplay ? { autoClose: millisToDisplay } : {});
            break;
        case 'ERROR':
            return react_toastify_1.toast.error(message, millisToDisplay ? { autoClose: millisToDisplay } : {});
            break;
        default:
            return react_toastify_1.toast(message, millisToDisplay ? { autoClose: millisToDisplay } : {});
    }
};
exports.notifyMessage = notifyMessage;
exports.default = AcToast;
AcToast.displayName = 'AcToast';
//# sourceMappingURL=AcToast.js.map